import 'focus-visible';

const newtemplateTag = '#main';
const oldtemplateTag = '#AT_Main_body';
const skipNavigationEl = document.querySelector('.at-skip-to-main-content');
const allSkipToAnchorLinks = document.querySelectorAll('.at-skip-to-anchor');

const BREAKPOINT_DESKTOP = 1280;
const DESKTOP_Y_OFFSET = 48;
const MOBILE_Y_OFFSET = 32;

const goToMainContent = (keyboard = false) => {
  // Wayfinding on BTF page has a url monitoring/routing that will override any invalid urls
  const wayfindingEl = document.querySelector('#at-wayfinding');
  if (wayfindingEl) {
    const oldTemplateEl = document.querySelector('#AT_Public_Transport');
    oldTemplateEl.setAttribute('tabindex', '0');
    oldTemplateEl.focus();
    oldTemplateEl.removeAttribute('tabindex');
    if (keyboard) wayfindingEl.classList.add('wayfinding--keyboard-active');
  } else {
    // Look for new template tag first
    const tag = document.querySelector(newtemplateTag) ? newtemplateTag : oldtemplateTag;
    // HOP has its own routing
    const locationReplacement = document.querySelector('.at-my-hop') ? `${window.location.pathname}${tag}` : tag;
    window.location.replace(locationReplacement);
  }
};

const handleSkipToAnchor = (event) => {
  event.preventDefault();

  const link = event.currentTarget;

  const targetSelector = link.getAttribute('href');

  if (targetSelector) {
    const targetElement = document.querySelector(targetSelector);

    if (targetElement) {
      const isDesktop = window.innerWidth >= BREAKPOINT_DESKTOP;
      const yOffset = isDesktop ? DESKTOP_Y_OFFSET : MOBILE_Y_OFFSET;

      const offsetPosition = targetElement.getBoundingClientRect().top + window.scrollY - yOffset;

      window.scrollTo({ top: offsetPosition, behavior: 'instant' });

      targetElement.setAttribute('tabindex', '0');
      targetElement.focus({ preventScroll: true });
      targetElement.removeAttribute('tabindex');
    }
  }
};

if (skipNavigationEl) {
  skipNavigationEl.addEventListener('click', goToMainContent);
  skipNavigationEl.addEventListener('keypress', (e) => {
    e.preventDefault();
    if (e.keyCode === 13 || e.key === 'Enter') {
      goToMainContent(true);
    }
  });
}

allSkipToAnchorLinks.forEach((link) => {
  link.addEventListener('click', handleSkipToAnchor);

  link.addEventListener('keypress', (e) => {
    if (e.key === 'Enter') {
      handleSkipToAnchor(e);
    }
  });
});